import { Button, Flex, Form, message, Modal, Space } from "antd";
import React, { useEffect, useState } from "react";
import { CitiesInput, CitiesTextEditor } from "../../components";
import { draftapi } from "../../services/draftapi";

const AddEditDraftNotes = ({ visible, onClose, editDraft, editItem, call }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (visible && editItem) {
      form.setFieldsValue({
        any_notes: editItem?.notes,
      });
      call();
    } else form.resetFields();
  }, [visible, editItem, form]);

  const AddEditNotes = async () => {
    setLoading(true);
    const data = form.getFieldsValue();
    try {
      const payload = {
        draft_id: editDraft?.id,
        any_notes: data?.any_notes,
        when_to_call_again: editDraft?.when_to_call_again,
      };
      const result = await draftapi?.addEditDraftNote(payload, editItem?.id);
      if (result?.success) {
        message.success(
          `Draft note ${editItem?.id ? "updated" : "saved"} successfully!`,
        );
        onClose();
        call();
      } else {
        message.error(
          result?.message ||
            `Failed to ${editItem?.id ? "update" : "save"} draft note`,
        );
      }
    } catch (error) {
      message.error(error || "Failed to load draft note");
    } finally {
      setLoading(false);
    }
  };
  return (
    <Modal
      title={editItem ? "Edit Note" : "Add Note"}
      centered
      open={visible}
      onCancel={onClose}
      footer={
        <Flex justify="end" gap={5}>
          <Button onClick={onClose}>Cancel</Button>
          <Button
            type="primary"
            loading={loading}
            onClick={() => form.submit()}
          >
            {(editItem ? "Update" : "Add") + " Note"}
          </Button>
        </Flex>
      }
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={true}
        onFinish={AddEditNotes}
        requiredMark={false}
      >
        <CitiesTextEditor
          name="any_notes"
          label="Note"
          placeholder="Write here..."
        />
      </Form>
    </Modal>
  );
};

export { AddEditDraftNotes };
